// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "nemo-header-" + (chunkId === 74 ? "lazy-search" : chunkId) + "-" + {"74":"85febe79634f5567483c","536":"6835af720df2bda027fe"}[chunkId] + ".js";
};